{
	"page": {
		"title": "Countries",
		"intro": "The full ISO-3166 list. The ones carrying an <strong>IOC code</strong> are competing — that code is what prints on the AC card, and it is not the ISO code.",
		"addCountry": "Add country",
		"count_one": "{{n}} country",
		"count_other": "{{n}} countries"
	},
	"filters": {
		"participation": "Participation",
		"competing": "Competing",
		"notCompeting": "Not competing",
		"searchPlaceholder": "Search by name, nationality or code"
	},
	"table": {
		"country": "Country",
		"ioc": "IOC",
		"iso": "ISO",
		"dial": "Dial",
		"people": "People",
		"updated": "Updated",
		"noDemonym": "no demonym",
		"iocTitle": "Olympic code — this is what prints on the AC card",
		"notCompetingTitle": "Not a competing nation",
		"isoTitle": "ISO-3166 alpha-3",
		"editLabel": "Edit {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} country",
		"summary_other": "{{from}}–{{to}} of {{total}} countries",
		"empty": "No countries"
	},
	"empty": {
		"filteredTitle": "No countries match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No countries yet",
		"noneDescription": "Run `pnpm db:seed` to load the ISO-3166 list.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add country",
		"addDescription": "The ISO-3166 list is already seeded. Add a row here only for something outside it — a refugee or neutral-athlete team, say.",
		"addSubmit": "Add country",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} person holds this nationality — a code change reaches every one of their cards.",
		"editInUse_other": "{{count}} people hold this nationality — a code change reaches every one of their cards.",
		"editEmpty": "Nobody holds this nationality yet.",
		"isoHint": "ISO-3166 alpha-3. This is the country's identity; every person of this nationality points at it.",
		"iocHint": "The Olympic code that prints on the AC card. Only competing nations have one — leave it blank otherwise.",
		"section": {
			"identity": "Identity",
			"identityCreateHint": "The name is what every screen shows. The ISO code cannot be changed afterwards.",
			"identityEditHint": "The ISO code is the row's identity and is not editable — a wrong one is a delete and re-create.",
			"codes": "Codes",
			"codesHint": "Different codes. Malaysia is MYS at ISO and MAS at the IOC.",
			"details": "Details",
			"detailsHint": "Shown on the card and used to prefill phone entry."
		},
		"field": {
			"name": "Name",
			"isoCode": "ISO code",
			"iocCode": "IOC code",
			"nationality": "Nationality",
			"nationalityHint": "The demonym — Malaysian, Filipino.",
			"callingCode": "Calling code",
			"callingCodeHint": "With the plus — +60.",
			"flagUrl": "Flag URL"
		},
		"placeholder": {
			"iso": "MYS",
			"ioc": "MAS",
			"iocEdit": "Not competing",
			"nationality": "Malaysian",
			"callingCode": "+60"
		}
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add country",
		"updateFailed": "Couldn't update country"
	},
	"errors": {
		"iocTaken": "Another country already uses that IOC code.",
		"isoTaken": "A country with that ISO code already exists.",
		"invalidValue": "Invalid value"
	},
	"sort": {
		"iocAsc": "IOC code A–Z",
		"iocDesc": "IOC code Z–A",
		"isoAsc": "ISO code A–Z",
		"isoDesc": "ISO code Z–A"
	},
	"stats": {
		"total": "Countries",
		"matching": "matching the filters",
		"competing": "Competing",
		"reference": "Reference only"
	}
}
